import { type Html, html, on, View } from 'rune-ts';
import klass from './MobileDropDown.module.scss';
import { cx } from '../util';
import { Icon } from '../Icon/Icon.ts';
import { QuestionMarkClickEvent } from '@modules/NewMaker/UI/SectionA/SectionA.ts';

export interface MobileDropDownData {
  title: string;
  helpText?: boolean;
  klass?: string;
  content: View | Html;
}

export class MobileDropDown extends View<MobileDropDownData> {
  protected get content(): View | Html {
    return this.data.content;
  }

  override template() {
    const { title, helpText, klass: customKlass } = this.data;

    return html`
      <div class="${cx(klass.mobileDropdown, customKlass)}">
        <div class=${klass.header}>
          <div class="${cx(klass.title)} ">${title}</div>
          ${helpText
            ? html`<div class="${klass.question_mark}">${new Icon({ name: 'information', size: 16 })}</div>`
            : ''}
        </div>
        <div class="${klass.content}">${this.content}</div>
      </div>
    `;
  }

  @on('click', `.${klass.question_mark}`)
  _onQuestionMarkClick() {
    this.dispatchEvent(QuestionMarkClickEvent, {
      bubbles: true,
      detail: this.data,
    });
  }
}
